import sendToast from '@/lib/sendToast';
import { postRunWorkflow } from '@/redux/actions/gravityActions.js';
import { store } from '@/redux/lib/configureStore';
import submitTutorialEvent from './submitTutorialEvent.js';

const runWorkflow = async ({ workflowId, environmentId, runPublished }, callback) => {
  submitTutorialEvent('run');
  const state = store.getState();
  const runEnvironment = state?.ui?.prefs?.[`workflowRunEnvironment-${workflowId}`];
  const defaultEnvironment = state?.settings?.environments?.find((env) => env.isDefault);
  const installationId = state?.workflow?.workflows?.find((w) => w?.id === workflowId)?.installationId;

  sendToast({ message: 'Running workflow...' });
  postRunWorkflow(
    {
      force: true,
      workflowId,
      environmentId: environmentId || runEnvironment || defaultEnvironment?.id,
      runPublished,
      installationId
    },
    callback
  );
};

export default runWorkflow;
